<template>
  <div class="content">
  </div>
</template>

<script>
export default {
  props:{
    options: Object
  }
}
</script>

<style lang="scss" scoped>
</style>
